
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Token } from './token/token';
import { TokenService } from './token/token.service';
import { LoginService } from './login/login.service';


@Injectable()
export class BackendService {

    private token: Token;

    constructor(private http: HttpClient, private router: Router, private tokenService: TokenService, private loginService: LoginService) { }

    setHeaders(token: Token, urlEncodedForm: boolean, isBucket: boolean = false, isFileDownload: boolean = false, isPerfiosLink: boolean = false, addApiVersionHeader: boolean = false, isVideoKycLink: boolean = false, customHeaders: any = {}): HttpHeaders {
        let additionalHeaders = new HttpHeaders();
        if (token && !isBucket) {
            if (this.checkIfTokenInLocalMatchesWithSession(token.access_token)) {
                additionalHeaders = additionalHeaders.set('Authorization', token.token_type + ' ' + token.access_token);
            } else {
                this.tokenService.logout(false);
                return null;
            }
        }
        if (urlEncodedForm) {
            additionalHeaders = additionalHeaders.set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
        } else {
            additionalHeaders = additionalHeaders.set('Content-Type', 'application/json');
            if (!isFileDownload) {
                additionalHeaders = additionalHeaders.set('Accept', 'application/json');
            }
        }
        if (isPerfiosLink) {
            additionalHeaders = additionalHeaders.set('tenant-id', environment.perfiosLinkTenantId);
        }
        if (addApiVersionHeader) {
            additionalHeaders = additionalHeaders.set('api-version', '1.1');
        }
        if (isVideoKycLink) {
            additionalHeaders = additionalHeaders.set('tenant-id', environment.videoKycLinkTenantId);
        }
        additionalHeaders = additionalHeaders.set('Cache-Control', 'no-cache');
        additionalHeaders = additionalHeaders.set('Pragma', 'no-cache');
        if (Object.keys(customHeaders).length !== 0) {
            for (const headerKey of Object.keys(customHeaders)) {
                additionalHeaders = additionalHeaders.set(headerKey, customHeaders[headerKey]);
            }
        }
        return additionalHeaders;
    }
    putData(url: string, postParams: any = {}, addPerfiosLinkHeader: any = false, addApiVersionHeader: any = false, addVideoKycLinkHeader: any = false, customHeaders: any = {}): Observable<any> {

        this.token = this.tokenService.getToken();
        const requestUrl = environment.baseUrl + url.replace('{customerId}', this.tokenService.getCustomerId());
        return this.http.put(requestUrl, postParams, { headers: this.setHeaders(this.token, false, false, false, addPerfiosLinkHeader, addApiVersionHeader, addVideoKycLinkHeader, customHeaders) }).pipe(
            catchError((error: any) => observableThrowError(error || 'Server error')));
    }
    patchData(url: string, postParams: any = {}): Observable<any> {
        this.token = this.tokenService.getToken();
        const requestUrl = environment.baseUrl + url.replace('{customerId}', this.tokenService.getCustomerId());
        return this.http.patch(requestUrl, postParams, { headers: this.setHeaders(this.token, false) }).pipe(
            catchError((error: any) => observableThrowError(error || 'Server error')));
    }
    getData(url: string = '', responseType: string = '', isRelative: boolean = false, skipToken: boolean = false, isBucket: boolean = false, isAbsolute: boolean = false, skip500ErrorCatch: boolean = false, isAuthenticationApi: boolean = false, isFileDownload: boolean = false): Observable<any> {
        this.token = this.tokenService.getToken();
        let requestUrl = url.replace('{customerId}', this.tokenService.getCustomerId());
        if (isAuthenticationApi) {
            requestUrl = environment.authUrl + url.replace('{customerId}', this.tokenService.getCustomerId());
        } else if (isBucket) {
            requestUrl = environment.s3BucketUrl + requestUrl;
        } else if (!isRelative) {
            requestUrl = environment.baseUrl + requestUrl;
        }
        if (isAbsolute) {
            requestUrl = url.replace('{customerId}', this.tokenService.getCustomerId());
        }
        const requestOptions = {
            headers: this.setHeaders(this.token, false, isBucket, isFileDownload)
        };
        if (responseType) {
            requestOptions['responseType'] = responseType;
        }
        return this.http.get(requestUrl, requestOptions).pipe(catchError((error: any) => {
            if (error.status === 401) {
                if (this.tokenService.getUnauthorizedRedirection()) {
                    const { url, params } = this.tokenService.getUnauthorizedRedirection();
                    this.router.navigate([url], {queryParams : { ...params } });
                } else {
                    this.tokenService.removeAll(false);
                    this.loginService.goToLoginUrl(true);
                }
            }
            if (error.status === 500 && !skip500ErrorCatch) {
                this.router.navigate(['/info-page/error'], { queryParams: { state: error.status } });
            }
            return observableThrowError(error || 'Server error');
        }));
    }
    getLenderData(url: string = ''): Observable<any> {
        this.token = this.tokenService.getToken();
        let requestUrl = url.replace('{customerId}', this.tokenService.getCustomerId());

        requestUrl = environment.lenderUrl + requestUrl;

        const requestOptions = {
            headers: this.setHeaders(this.token, false)
        };

        return this.http.get(requestUrl, requestOptions).pipe(catchError((error: any) => {
            if (error.status === 401) {
                this.tokenService.removeAll(false);
                this.loginService.goToLoginUrl(true);
            }
            if (error.status === 500) {
                this.router.navigate(['/info-page/error'], { queryParams: { state: error.status } });
            }
            return observableThrowError(error || 'Server error');
        }));
    }
    setData(url: string, postParams: any = {}, responseType: string = '', urlEncodedForm: boolean = false, isAbsolute: boolean = false, skip500ErrorCatch: boolean = false, isAuthenticationApi: boolean = false, customHeaders: any = {}): Observable<any> {
        this.token = this.tokenService.getToken();
        let requestUrl = environment.baseUrl + url.replace('{customerId}', this.tokenService.getCustomerId());
        if (isAuthenticationApi) {
            requestUrl = environment.authUrl + url.replace('{customerId}', this.tokenService.getCustomerId());
        }
        if (isAbsolute) {
            requestUrl = url.replace('{customerId}', this.tokenService.getCustomerId());
        }
        const requestOptions = {
            headers: this.setHeaders(this.token, urlEncodedForm, false, false, false, false, false, customHeaders )
        };
        if (responseType) {
            requestOptions['responseType'] = responseType;
        }
        return this.http.post(requestUrl, postParams, requestOptions).pipe(catchError((error: any) => {
            if (error.status === 401) {
                this.tokenService.removeAll(false);
                this.loginService.goToLoginUrl(false);
            }
            if (error.status === 500 && !skip500ErrorCatch) {
                this.router.navigate(['/info-page/error'], { queryParams: { state: error.status } });
            }
            return observableThrowError(error || 'Server error');
        }));
    }
    deleteData(url: string = '', skip500ErrorCatch: boolean = false): Observable<any> {
        this.token = this.tokenService.getToken();
        let requestUrl = url.replace('{customerId}', this.tokenService.getCustomerId());
        requestUrl = environment.baseUrl + requestUrl;
        return this.http.delete(requestUrl, { headers: this.setHeaders(this.token, false) }).pipe(catchError((error: any) => {
            if (error.status === 401) {
                this.tokenService.removeAll(false);
                this.loginService.goToLoginUrl(false);
            }
            if (error.status === 500 && !skip500ErrorCatch) {
                this.router.navigate(['/info-page/error'], { queryParams: { state: error.status } });
            }
            return observableThrowError(error || 'Server error');
        }));
    }
    checkIfTokenInLocalMatchesWithSession(sessionToken: string): Boolean {

        if (sessionToken) {
            return true;
        }
        return false;
    }
    setHeadersForAPIGateway(apiKey?: string) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('x-api-key', apiKey ? apiKey : environment.featureSwtichApi);
        return headers;
    }
    getCallForAPIGateway(url: string, baseUrl?: string, apiKey?: string): Observable<any> {
        const base = baseUrl ? environment[baseUrl] : environment.featureSwitchBaseUrl;
        url = base + url;
        const akey = apiKey ? environment[apiKey] : null;
        // url = environment.featureSwitchBaseUrl + url;
        return this.http.get(url, { headers: this.setHeadersForAPIGateway(akey) }).pipe(catchError((error: any) => {
            return observableThrowError(error || 'Server error');
        }));
    }
    postCallForAPIGateway(url: string, postParams: any = {}, baseUrl?: string, apiKey?: string): Observable<any> {
        const base = baseUrl ? environment[baseUrl] : environment.featureSwitchBaseUrl;
        url = base + url;
        const akey = apiKey ? environment[apiKey] : null;
        return this.http.post(url, postParams, { headers: this.setHeadersForAPIGateway(akey) }).pipe(catchError((error: any) => {
            return observableThrowError(error || 'Server error');
        }));
    }
    postCallForLogger(url: string, postParams: any= {}): Observable<any> {
        try {
          url = environment.appUrl + url;
          return this.http.post(url, postParams).pipe(catchError((error: any) => {
            console.error(error);
            return observableThrowError(error || 'Server error');
        }));
        } catch (e) {
            console.error(e);
        }
    }
    getCallForWhiteList(url: string): Observable<any> {
        url = environment.apiGatewayBaseUrl + url;
        return this.http.get(url, { headers: this.setHeadersForAPIGateway(environment.whiteListApi) }).pipe(catchError((error: any) => {
            return observableThrowError(error || 'Server error');
        }));
    }
    setHeadersForThirdPartyServiceCall(token: string) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('Authorization', token);
        return headers;
    }
    getCallForThirdPartyService(url: string, token: string = '') {
        return this.http.get(url, { headers: this.setHeadersForThirdPartyServiceCall(token) }).pipe(catchError((error: any) => {
            return observableThrowError(error || 'Server error');
        }));
    }
    getCallForMerchantList(url: string): Observable<any> {
        url = environment.apiGatewayBaseUrl + url;
        return this.http.get(url, { headers: this.setHeadersForAPIGateway(environment.merchantSettingsApiKey) }).pipe(catchError((error: any) => {
            return observableThrowError(error || 'Server error');
        }));
    }
}
